import { noValue } from '@ecomm/utils'
import type { ActivePromoBannerType } from './types'

const promoBannerStyleMapper: { [key: string]: ActivePromoBannerType } = {
  Cart: 'cart',
  None: 'none',
  'PDP/PLP': 'pdp-plp',
  Standard: 'standard'
}

export const toPromoBannerStyleValue = (
  value: string | null | undefined
): ActivePromoBannerType | undefined =>
  value ? promoBannerStyleMapper[value] : noValue()
